module.exports = __webpack_public_path__ + "media/images/home/screen_12-410812b6b0027ec9236f758543015de5.png";